export default "__VITE_ASSET___RTrw95R__"